if (!window.__mtInit) {
  window.__mtInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCifras();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initCifras() {
  var els = document.querySelectorAll('.mt-cifra[data-hasta]');
  if (!els.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var hasta = parseFloat(el.getAttribute('data-hasta')) || 0;
      var sufijo = el.getAttribute('data-sufijo') || '';
      if (prefersReduced) {
        el.textContent = hasta + sufijo;
        return;
      }
      var inicio = 0;
      var duracion = 1400;
      var t0 = null;
      function paso(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / duracion, 1);
        var valor = Math.floor(inicio + (hasta - inicio) * (1 - Math.pow(1 - p, 3)));
        el.textContent = valor + sufijo;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}
